var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ROBBERY_SECURIZATION_METHOD_CHOICES } from '@shared/constants/robberyConstants';
import { RobberySecurizationMethod } from '@shared/types/api/claim';
const claim = namespace('claim');
const qualification = namespace('qualification');
let RobberyHouseSecuredQuestion = class RobberyHouseSecuredQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.securizationMethodeChoices = ROBBERY_SECURIZATION_METHOD_CHOICES;
    }
    updateClaim(homeSecured) {
        this.updateAndSaveQualification({
            qualificationPayload: { homeSecured },
            step: this.step,
        });
    }
    get answer() {
        if (this.qualification.homeSecured === null) {
            return null;
        }
        return this.qualification.homeSecured === RobberySecurizationMethod.AssistanceNeeded
            ? this.$tc('claim.qualification.robbery.house_secured.answer.no')
            : this.$tc('claim.qualification.robbery.house_secured.answer.yes');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], RobberyHouseSecuredQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], RobberyHouseSecuredQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], RobberyHouseSecuredQuestion.prototype, "updateAndSaveQualification", void 0);
RobberyHouseSecuredQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], RobberyHouseSecuredQuestion);
export default RobberyHouseSecuredQuestion;
